import { Container } from '@material-ui/core';
import axios from 'axios'
import {SetStateAction, useEffect, useState, useContext} from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Context } from '../../context/Context';
import MainNav from '../Navbar/MainNav';
import PostTemplate from '../PostTemplate';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from '../footer/Footer';
import '../../assets/css/AllPost.css'
import LoadingSpinner from '../spinner/LoadingSpinner';
import PaginationButton from '../pagination/PaginationButton';
import { axiosInstance } from "../../utils";


const AllPosts = () => {
    const [loading, setLoading] = useState(false);
    const [allpost, setAllPost] = useState<any[]>([]);
    const location = useLocation();
    const path = location.pathname.split('/')[2];
    console.log(allpost);

    const {user, isFetching, dispatch} = useContext(Context);

  //pagination state 
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(9);
  //change pages 
   const paginate = (pageNumber: SetStateAction<number>) => setCurrentPage(pageNumber);

  //current Post 
    const indexOfLastPost = currentPage * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;
    const currentPosts = allpost.slice(indexOfFirstPost, indexOfLastPost);




const fetchAllPost = async () => {
    setLoading(true);
    const res = await axiosInstance.get('/posts')
    setAllPost(res.data);
    setLoading(false);
}

    //show all the blog post
    const renderAllPost = currentPosts.map(post => {
      return (
          <Col xs={12} sm={6} md={4} lg={3}>
          <PostTemplate id={post._id} 
            title={post.title} 
            photo={post.photo} 
            desc={post.desc} 
            author={post.author} 
            createdAt={post.createdAt}/>
          </Col>
      )
  })

  //user only admin posts
  const ShowUserPost = currentPosts.map(post => {
    // <h3>you have not created any post yet</h3>
    if (user?.username === post.author) {
      return (
           <Col xs={12} sm={6} md={4} lg={3}>
            <PostTemplate id={post._id} 
          title={post.title} 
          photo={post.photo} 
          desc={post.desc} 
          author={post.author} 
          createdAt={post.createdAt}/>
          </Col>
      )
    }
  })


    console.log(isFetching);

    useEffect(() => {
        fetchAllPost();
    },[])
  return (
    <div className='controll__footer'>
      <MainNav />
      {loading ? <LoadingSpinner /> :
      <Container className='all_blog_post_wrapper'>
        <Row>
          <h2>All posts</h2>
          {user? ShowUserPost : renderAllPost}
        </Row>
        {postPerPage > 9 && 
        <div className='pagination__wrapper'>
          <PaginationButton 
            postsPerPage={postPerPage} 
            totalPosts={allpost.length} 
            paginate={paginate} 
          />
        </div>}
      </Container>}
      <Footer/>      
    </div>
  )
}

export default AllPosts
